import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const IMG_SMALL = '/webclient/sk_core/images/place_small.png';
const IMG_LARGE = '/webclient/sk_core/images/place_medium.png';

const ImageSection = ({ title, imgSmall, imgLarge }) => (
  <div className="history col-md-3 col-xs-6">
    <div className="row">
      <div className="col-xs-12">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <img
              alt={title}
              src={imgLarge || IMG_LARGE}
              loading="lazy"
              className="hidden-xs img-horinzontal"
            />
            <img
              alt={title}
              src={imgSmall || IMG_SMALL}
              loading="lazy"
              className="hidden-lg hidden-md hidden-sm img-vertical"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

ImageSection.propTypes = {
  title: PropTypes.string,
  imgSmall: PropTypes.string,
  imgLarge: PropTypes.string,
};

export default ImageSection;
